"use client";

import { useState, useEffect } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';

export default function ThemeToggle() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    // On component mount, check if user has a theme preference in localStorage
    const isDark = localStorage.getItem('theme') === 'dark';
    setDarkMode(isDark);
    
    // Apply the theme class to the document
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  const toggleTheme = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    
    // Update localStorage and document class
    if (newDarkMode) {
      localStorage.setItem('theme', 'dark');
      document.documentElement.classList.add('dark');
    } else {
      localStorage.setItem('theme', 'light');
      document.documentElement.classList.remove('dark');
    }
  };

  return (
    <div className="flex items-center">
      <span className="mr-2 text-yellow-500"><FaSun /></span>
      <label className="toggle-switch">
        <input 
          type="checkbox" 
          checked={darkMode} 
          onChange={toggleTheme}
        />
        <span className="toggle-slider"></span>
      </label>
      <span className="ml-2 text-blue-500"><FaMoon /></span>
    </div>
  );
}